import React, { Component }  from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearUserProfile } from '../redux/actions/user';
import { clearBugsnagUser } from '../redux/actions/bugsnag';
import Alerts from '../prototypes/Alerts';
import RouteTitle from './RouteTitle';
import ToggleButton from './ToggleButton';
import Loadable from 'react-loadable';
// import DashboardPanel from './DashboardPanel';

const LoadableDashboardPanel = Loadable( {
  loader: () => import( /* webpackChunkName: "DashboardPanelChunk" */ './DashboardPanel' ),
  loading: () => <div> LOADING </div>,
} );

class DashboardContainer extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      layout: props.layout === undefined ? {} : props.layout,
      showsettingsmenu: false,
    };
    
    this.onRenderData = this.onRenderData.bind( this );
    this.onGridFormatItem = this.onGridFormatItem.bind( this );
    this.onShowSettingsMenu = this.onShowSettingsMenu.bind( this );
    this.onHideSettingsMenu = this.onHideSettingsMenu.bind( this );
    this.onToggleDashboard = this.onToggleDashboard.bind ( this );
  }

  compareProps( currentProps, nextProps ) {
    const currentLayout = currentProps.layout;
    const nextLayout = nextProps.layout;
    if( currentLayout !== undefined && nextLayout !== undefined ) {
      if( currentLayout.visible !== nextLayout.visible ) {
        return false;
      }
    }
    return true;
  }

  componentWillReceiveProps( nextProps ) {
    if( this.compareProps( this.props, nextProps ) === true ) {
      this.setState( {
        layout: nextProps.layout === undefined ? {} : nextProps.layout
      } );
    }
  }

  doLogOff( ) {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const layout = this.state.layout;
    const title = layout.caption;
    const { bugsnag, dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if( status === 410 ) {
      alerts.INFO( title, 'Your session has expired.' , 5000 );
      this.doLogOff();
    } else if ( status === 503 ) {
      alerts.CRITICAL( title, 'The API server is unreachable for this request. Please retry request at a later time. If the problem persists please submit a help desk ticket.' );
    } else if( status === 500 ) {
      alerts.INFO( title, e.statusText , 5000 );
    } else if( status === 400 ) {
      alerts.WARNING( title, 'Request timed out.', 5000 );
    } else {
      alerts.CRITICAL( title, e );
    }  
  }
  

  onShowSettingsMenu( e ) {
    this.setState( {
      showsettingsmenu: true
    } );
  }

  onHideSettingsMenu( e ) {
    this.setState( {
      showsettingsmenu: false
    } );
  }

  onToggleDashboard( e, visible ) {
    let layout = this.state.layout;
    const caption = e.target.column;
    if( layout !== undefined ) {
      let dashboards = layout.dashboards;
      if( dashboards !== undefined ) {
        if( dashboards.length > 0 ) {
          for( let index = 0; index < dashboards.length; index++ ) {
            if( dashboards[ index ].caption === caption ) {
              dashboards[ index ].visible = visible;
            }
          }
          this.setState( {
            layout: layout
          } );
        }
      }
    }
  }

  getPanelVisible( dashboardkey, defaultValue ) {
    const key = dashboardkey + '.visible';
    if( localStorage !== undefined && localStorage !== null ) {
      let visible = localStorage.getItem( key );
      visible = ( visible === undefined || visible === null ) ? defaultValue : visible;
      visible = visible === 'true' ? true : visible; 
      visible = visible === 'false' ? false : visible;
      return visible;
    }
    return true;
  }

  setPanelVisible( dashboardkey, value ) {
    const key = dashboardkey + '.visible';
    if( localStorage !== undefined && localStorage !== null ) {
      localStorage.setItem( key, value );
    }
  }

  onRenderData( key, data ) {
    if( this.props.onRenderData !== undefined ) {
      return this.props.onRenderData( key, data );
    }
    return data;
  }

  onGridFormatItem( key, panel, e ) {
    if( this.props.onGridFormatItem !== undefined ) {
      this.props.onGridFormatItem( key, panel, e );
    }
  }

  onRenderDashboardContainerHeader() {
    const layout = this.state.layout;
    const caption = layout.caption;
    let headers = [];

    headers.push( 
      <span key="dashboard-container-header-caption" className="dashboard-container-header-caption">
        {caption}
      </span>
    );

    if( this.state.showsettingsmenu === false ) {
      headers.push( 
        <span key="dashboard-container-header-cog" className="dashboard-container-header-cog" onClick={this.onShowSettingsMenu}>
          <i className="icon-fontello-cog-1" />
        </span>
      );
    } else {
      headers.push( 
        <span key="dashboard-container-header-cog" className="dashboard-container-header-cog" onClick={this.onHideSettingsMenu}>
          <i className="icon-fontello-cog-1" />
        </span>
      );

      if( layout !== undefined ) {
        const dashboards = layout.dashboards;
        let availabledashboards = dashboards.map( ( dashboard, index ) => {
          const dashboardmenuitemkey = 'dashboard-container-header-cog-menu"-item-' + index.toString();
          return (
            <div key={dashboardmenuitemkey} className="dashboard-container-header-cog-menu-item">
              <span className="dashboard-container-header-cog-menu-item-caption">
                {dashboard.caption}
              </span>
              <span className="dashboard-container-header-cog-menu-item-toggle">
                <ToggleButton is_switched_on={dashboard.visible} column={dashboard.caption} onToggle={this.onToggleDashboard} />
              </span>
            </div>
          );
        } );

        headers.push(
          <div key={'dashboard-container-header-cog-menu'} className="dashboard-container-header-cog-menu">
            <div className="dashboard-container-header-cog-menu-header">
              <span className="dashboard-container-header-cog-menu-header-caption">
                Dashboard Settings
              </span>
              <span className="dashboard-container-header-cog-menu-header-close-button">
                <i className='icon-ikons-close' onClick={this.onHideSettingsMenu} />
              </span>
            </div>
            <div className="dashboard-container-header-cog-menu-items">
              {availabledashboards}
            </div>
          </div>
        );
      }
    }

    return headers;
  }

  onRenderDashboardContainerBody() {
    const layout = this.state.layout;
    let panels = [];
    if( layout !== undefined ) {
      const dashboards = layout.dashboards;
      if( dashboards !== undefined ) {
        if( dashboards.length > 0 ) {
          dashboards.map( ( dashboard, index ) => {
            const panelKey = 'dashboard-panel-item-' + index.toString();
            panels.push( 
              <LoadableDashboardPanel 
                key={panelKey} 
                caption={dashboard.caption} 
                expanded={dashboard.expanded} 
                canexport={dashboard.canexport}
                refresh={dashboard.refresh}
                refreshRate={dashboard.refreshRate}
                visible={dashboard.visible}
                height={dashboard.height === undefined ? "auto" : dashboard.height}
                width={dashboard.width}
                class={dashboard.class} 
                type={dashboard.type}
                routes={dashboard.routes}
                headers={dashboard.headers}
                filters={dashboard.filters} 
                onRenderData={this.onRenderData}
                onGridFormatItem={this.onGridFormatItem}
                onHideDashboard={this.onToggleDashboard} 
              />
            );
            return dashboard;
          } );
        }
      }
    }
    return panels;  
  }

  onRenderDashboardContainerFooter() {
    const layout = this.state.layout;
    if( layout !== undefined ) {
      const dashboards = layout.dashboards;
      if( dashboards !== undefined ) {
        if( dashboards.length > 1 ) {
          return (
            <span className="dashboard-container-footer-dashboard-counts">
              There are {dashboards.length} dashboards.
            </span>
          );    
        } else {
          return (
            <span className="dashboard-container-footer-dashboard-counts">
              There is {dashboards.length} dashboard.
            </span>
          );    
        }
      }
    }
    return (
      <span className="dashboard-container-footer-dashboard-counts">
        There are no dashboards
      </span>
    );    
  }

  render() { 
    const layout = this.state.layout;
    const caption = layout === undefined ? '' : layout.caption;
    return (
      <div className="dashboard-container">
        <RouteTitle title={caption} />        
        <div className="dashboard-container-header">
          {this.onRenderDashboardContainerHeader()}
        </div>
        <div className="dashboard-container-body">
          {this.onRenderDashboardContainerBody()}
        </div>
        <div className="dashboard-container-footer">
          {this.onRenderDashboardContainerFooter()}
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( DashboardContainer ) );



// WEBPACK FOOTER //
// ./src/presentation/DashboardContainer.js